import { getEncodedUrlForVroom } from 'owa-data-provider-info-fetcher';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { format } from 'owa-string-utils';
import { parse as parseUrl } from 'url';
import getRequest, { FileProviderRequestSet } from '../utils/FileProviderQueryConfig';
import { getResponseFromFileProvider } from '../utils/getResponseFromFileProvider';
import { CreateSharingLinkFromFileProviderResult } from './CreateSharingLinkFromFileProviderResult';

export async function createSharingLinkFromOneDrivePro(
    originalUrl: string,
    providerEndpointUrl: string
): Promise<CreateSharingLinkFromFileProviderResult> {
    const request: FileProviderRequestSet = getRequest(AttachmentDataProviderType.OneDrivePro);

    let hostname = parseUrl(originalUrl).hostname;

    /* The location field of group files doesn't have domain name so need to get it from providerEndpointUrl.
       We also need to compose full url (originalUrl) from providerEndpointUrl and file name and pass it along. */
    if (hostname === null && providerEndpointUrl) {
        hostname = parseUrl(providerEndpointUrl).hostname;
        originalUrl = 'https://' + hostname + originalUrl;
    }

    const requestUrl: string = format(
        request.create_shared_link_request.requestUrlFormat,
        hostname,
        getEncodedUrlForVroom(originalUrl)
    );

    const responseText: string = await getResponseFromFileProvider(
        request.providerType,
        requestUrl,
        request.create_shared_link_request.additional_headers,
        request.create_shared_link_request.method,
        null, // request body
        originalUrl,
        request.create_shared_link_request.dataPointName
    );

    return JSON.parse(responseText).value[0];
}
